/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Request_New_LinkInputs */

const en_password_reset_request_new_link = /** @type {(inputs: Password_Reset_Request_New_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a new link`)
};

const es_password_reset_request_new_link = /** @type {(inputs: Password_Reset_Request_New_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar un enlace nuevo`)
};

/**
* | output |
* | --- |
* | "Request a new link" |
*
* @param {Password_Reset_Request_New_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_request_new_link = /** @type {((inputs?: Password_Reset_Request_New_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Request_New_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_request_new_link(inputs)
	return en_password_reset_request_new_link(inputs)
});